import { Alert as AntAlert } from "antd";

const Alert = AntAlert;

export default Alert;
